import {Platform} from 'react-native';
import type BottomSheet from '@gorhom/bottom-sheet';

export type BackdropPressArgs = {
  onClose: () => void;
  bottomSheetRef?: React.RefObject<BottomSheet> | null;
  isWeb?: boolean;
};

export function handleBackdropPressHelper({
  onClose,
  bottomSheetRef,
  isWeb = Platform.OS === 'web',
}: BackdropPressArgs) {
  if (isWeb) {
    onClose();
    return;
  }
  if (bottomSheetRef?.current) {
    try {
      bottomSheetRef.current.forceClose();
    } catch {
      onClose();
    }
  } else {
    onClose();
  }
}
